module.exports = __webpack_public_path__ + "img/tmslg-currency-guide-2.7d4d86b0.png";